import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Norway
 */
export const NoPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/bookinger'],
  [IPageName.bookingDetailsPage]: ['/bookinger/:bookingId/details'],
  [IPageName.cancellationPage]: ['/bookinger/:bookingId/cancellation'],
};
